import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Icon } from "@/components/Icon";
import { consumeDemoEntryToast } from "./demoEntryToastSession";
import { useIsDemoUser } from "./useIsDemoUser";

const AUTO_DISMISS_MS = 6000;

export function DemoEntryToast() {
  const { t } = useTranslation();
  const isDemo = useIsDemoUser();
  const [visible, setVisible] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    if (!isDemo || !consumeDemoEntryToast()) return;
    setMounted(true);
    const enter = window.requestAnimationFrame(() => setVisible(true));
    const timer = window.setTimeout(() => setVisible(false), AUTO_DISMISS_MS);
    return () => {
      window.cancelAnimationFrame(enter);
      window.clearTimeout(timer);
    };
  }, [isDemo]);

  useEffect(() => {
    if (!mounted || visible) return;
    const timer = window.setTimeout(() => setMounted(false), 240);
    return () => window.clearTimeout(timer);
  }, [mounted, visible]);

  if (!mounted) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="demo-entry-toast"
      style={{
        position: "fixed",
        right: "max(16px, env(safe-area-inset-right, 0px))",
        bottom: "max(16px, env(safe-area-inset-bottom, 0px))",
        zIndex: 1000,
        maxWidth: "min(360px, calc(100vw - 32px))",
        padding: "12px 14px 12px 16px",
        display: "flex",
        alignItems: "flex-start",
        gap: 10,
        fontSize: 13,
        lineHeight: 1.45,
        color: "var(--ink-2)",
        background: "var(--paper)",
        border: "1px solid var(--line)",
        borderRadius: 12,
        boxShadow: "0 8px 24px rgba(0, 0, 0, 0.1)",
        opacity: visible ? 1 : 0,
        transform: visible ? "translateY(0)" : "translateY(8px)",
        transition: "var(--t-med)",
        pointerEvents: visible ? "auto" : "none",
      }}
    >
      <span style={{ flex: 1 }}>{t("demo.banner")}</span>
      <button
        type="button"
        className="btn-icon"
        aria-label={t("common.close")}
        onClick={() => setVisible(false)}
        style={{ flexShrink: 0, marginTop: -2 }}
      >
        <Icon name="x" size={14} />
      </button>
    </div>
  );
}
